<script setup>
import {getLogo} from "@/helpers/logo";
import {formatThousands} from "@/helpers/string";
import StartupTrackersPopup from "@/components/startups/StartupTrackersPopup.vue";
import {ref, computed, watch} from "vue";
import {useStore} from "vue2-helpers/vuex";
import AddTracker from "@/components/trackers/TrackerProjectEdit.vue";
import trackersCompaniesService from "@/services/trackers-companies.service";
import startupsService from "@/services/startups.service";
import trackersCompanies from "@/services/trackers-companies.service";

const props = defineProps(['startup']);
const store = useStore();

const trackers = ref([]);
const addTrackerModal = ref(null);

const actualTrackersList = computed(() => store.getters.trackersList.filter(tracker => !trackers.value.some(startupTracker => startupTracker.id === parseInt(tracker.id))));

watch(() => props.startup, (value) => {
    trackers.value = value.trackers;
}, {immediate: true});

async function getTrackers() {
    const {data} = await startupsService.getTrackers(props.startup.id);

    trackers.value = data;
}

function addNewTracker() {
    addTrackerModal.value.open(0, 'private');
}

async function trackerCreated(trackerId) {
    store.dispatch('fetchTrackers', true);
    addToTracker(trackerId);
}

function confirmAddToTracker(trackerId) {
    if (confirm('Add startup to selected tracker?')) {
        addToTracker(trackerId);
    }
}

async function addToTracker(trackerId) {
    await trackersCompaniesService.addCompanies([trackerId], [props.startup.id]);
    getTrackers();
}

async function removeFromTracker(trackerId) {
    if (confirm('Remove startup from selected tracker?')) {
        await trackersCompanies.removeCompanies(trackerId, [props.startup.id]);
        getTrackers();
    }

}
</script>

<template>
    <li>
        <figure class="image-block image-block--sm">
            <img :src="getLogo(startup.logo)" alt="">
        </figure>

        <div>
            <p><a :href="`/startups/${startup.id}`" target="_blank">{{startup.name}}</a> {{startup.description}}</p>

            <ul class="list-result__stat">
                <li v-if="startup.country" class="list-result__stat__location">
                    <span class="fi" :class="`fi-${startup.country_code}`"></span>
                    {{startup.country}}
                </li>
                <li v-if="startup.stage" class="list-result__stat__startups">{{startup.stage}}</li>
                <li v-if="startup.irl_score" class="list-result__stat__irl">IRL Score {{startup.irl_score}}</li>
                <li v-if="startup.total_raised" class="list-result__stat__funding">{{formatThousands(startup.total_raised)}} raised</li>
            </ul>
        </div>

        <div class="list-result__actions">
            <a v-if="false" href="#" class="list-result__actions__add"></a>
            <a
                :id="`trackers-link-${startup.id}`"
                class="list-result__actions__track"
            />
            <span v-if="trackers.length">{{trackers.length}}</span>
        </div>

        <StartupTrackersPopup
            :target="`trackers-link-${startup.id}`"
            :trackers="trackers"
            :options="actualTrackersList"
            @addNew="addNewTracker"
            @add="confirmAddToTracker"
            @remove="removeFromTracker"
        />

        <AddTracker
            ref="addTrackerModal"
            @trackerSaved="trackerCreated"
        />
    </li>
</template>

<style scoped>

</style>
